var OrganizationHierarchicalTree;

import OrganizationHierarchicalNode from './organizagion_hierarchical_node.js';

import {
  node_change_mixins
} from './mixins.js';

export default OrganizationHierarchicalTree = Vue.extend({
  mixins: [node_change_mixins],
  props: {
    tree: {
      type: Object
    },
    selectedOrganizationId: {
      type: Number
    },
    initialSelectedNodeAncestry: {
      type: Array
    },
    profileSchema: {
      type: Object,
      default: null
    }
  },
  components: {
    'hierarchical-select-node': OrganizationHierarchicalNode
  },
  template: `<div class='hierarchical-select-tree'>
  <hierarchical-select-node
    :node='tree.root'
    :selectedOrganizationId='selectedOrganizationId'
    :initialSelectedNodeAncestry='initialSelectedNodeAncestry'
    :profileSchema='profileSchema'
    @organizationDeleted='onOrganizationDeleted'
    @organizationSelected='onOrganizationSelected'
    ref='root' />
</div>`
});
